import { AccountNavButton } from "../../../Views/Account/Components/AccountNavItem";
import { ReactComponent as LogoutIcon } from "@icons/logout.svg";
import { useTranslation } from "react-i18next";
import { NavMenuItem } from "UIPalette/AppLayout/Components/TopNavBar";

export const Logout = ({ type, handleLogout }: { handleLogout: () => void; type?: "nav" | "account" }) => {
  const { t } = useTranslation();
  const label = t("navigation.userAccountMenu.logout");
  const navLabel = t("account.logOut");

  switch (type) {
    case "nav":
      return <NavMenuItem text={navLabel} Icon={LogoutIcon} onClick={handleLogout} />
    case "account":
    default:
      return <AccountNavButton bottomLine onClick={handleLogout} text={label} Icon={LogoutIcon} />;
  }
};
